import React, { useEffect, useState } from "react";
import { Box, Grid } from '@mui/material'; 
import { connect } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import KPIService from "../../../services/console_services/KPI";
import MapService from "../../../services/console_services/Map";
import FilterServices from "../../../services/FilterServices";
import TabComponent from "../../../common/Components/TabComponent";
import AlertDialogBox from "../../../common/Components/AlertDialogBox";
import ViewAllAlerts from "../../../common/Components/ViewAllAlerts";
import { makeStyles } from '@material-ui/core/styles' ;
import useTabList from "../../../common/TabList";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: "20px 20px 10px 80px", 
  },
  gridItem: {
    paddingTop: theme.spacing(2),
  },
}));

const DemandSupplyPlanning = ({ tabIndex, _Network, _DC, _Products, _Date, applyFilter }) => {
  const classes = useStyles(); 
  const { instance } = useMsal();

  const [KPIData, setKPIData] = useState({});
  const [mapData, setMapData] = useState([]);
  const [MapLoading, setMapLoading] = useState(false);
  const [KPILoading, setKPILoading] = useState(true);
  const [viewAll, setViewAll] = useState(false);
  const TabList = useTabList();

  const getKPIData = (params) => {
    setKPILoading(true);
    KPIService.getKPI(params, instance)
      .then(data => {
        if(data?.response){
          setKPIData(data?.response);
        }
      })
      .catch(error => console.error('Error:', error))
      .finally(()=>setKPILoading(false));
  };

  const getMAPData = (params) => {
    setMapLoading(true);
    MapService.getMAP(params, instance).then(data => {
      if(data?.data){
        setMapData(data?.data);
      }
    })
    .catch(error => console.error('Error:', error))
    .finally(() => setMapLoading(false));
  };

  useEffect(() => {
    const params = {
      name: "SNO",
      "filter": {
      "RecommendedDC":5410
      }
    };
    getKPIData(params);
    getMAPData(params);
    // getFiltersData(params);
  }, [tabIndex, applyFilter]);

  const handleViewAll = () => {
    setViewAll(!viewAll);
  };

  return (
    <Box className={classes.root}>
      {!viewAll ? (
        <Grid container spacing={2}>
          <Grid item xs={12} md={9}>
            <Grid item xs={12} md={12}>
              <TabComponent 
              KPIData={KPIData} 
              mapData={mapData} 
              tabList={TabList["DemandSupplyPlanning"]} 
              MapLoading={MapLoading} 
              KPILoading={KPILoading}
              Module={"FGS_POOS"} />
            </Grid>
          </Grid>
          <Grid item xs={12} md={3} className={classes.gridItem} sx={{ mt: '93px' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <AlertDialogBox handleViewAll={handleViewAll} viewAll={viewAll} />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      ) : (
        <ViewAllAlerts viewAll={viewAll} handleClose={handleViewAll} />
      )}
    </Box>
  );
};

const mapStateToProps = state => ({
  tabIndex: state.tabs.index,
  Network: state.filter.Network,
  DC: state.filter.DC,
  Products: state.filter.Products,
  Date: state.filter.Date,
  applyFilter: state.filter.applyFilter,
});

export default connect(mapStateToProps)(DemandSupplyPlanning);
